export enum Stamp {
  Passing = 1 << 0,
  Failing = 1 << 1,
  UnableToProcess = 1 << 2,
  LabPassedTest = 1 << 3,
  PtcPassedTest = 1 << 4,
  LabFailedTest = 1 << 5,
  PtcFailedTest = 1 << 6,
}
